<template>
<d-action-dialog
  v-bind:value="value"
  v-on:input="$emit('input', $event)"
  :onSave="onSave"
  confirmText="Löschen"
  denyText="Abbrechen"
>
  <template slot="title">
    Lizenz freigeben
  </template>
  <template>
    {{ text }}
  </template>
</d-action-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    id: {
      type: Number,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    license: {
      type: String,
      required: false
    },
    suspended: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    ...mapActions('users', ['deleteAssistAssoc']),
    onSave() {
      this.deleteAssistAssoc(this.id);
    }
  },
  computed: {
    text() {
      if (this.suspended) {
        return `Möchten Sie dem Benutzer ${this.name} aus der Lizenzliste entfernen?`
      }
      return `Möchten Sie dem Benutzer ${this.name} die Lizenz DRK-Assist ${this.license} wirklich entziehen?`
    }
  }
}
</script>
